import classNames from 'classnames';
import React from 'react';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import {
  ChatWidgetPreviewChannelOption,
  ChatWidgetPreviewChannelOptionLabels,
  ChatWidgetPreviewChannelOptions,
  ChatWidgetPreviewFrame,
} from '../ChatWidgetPreviewFrame/ChatWidgetPreviewFrame';
import './CustomerChatPreview.pcss';

type Props = {
  promoter: PromoterModel;
  channel: ChatWidgetPreviewChannelOption;
  setChannel: (channel: ChatWidgetPreviewChannelOption) => void;
};

export const CustomerChatPreview = (props: Props) => {
  const { promoter, channel, setChannel } = props;

  return (
    <div className="customer-chat-preview">
      <div className="customer-chat-preview__channel-options">
        {ChatWidgetPreviewChannelOptions.map(c => (
          <div
            key={c}
            className={classNames('customer-chat-preview__channel-option', {
              'customer-chat-preview__channel-option--selected': channel === c,
            })}
            onClick={() => setChannel(c)}
          >
            {ChatWidgetPreviewChannelOptionLabels[c]} Preview
          </div>
        ))}
      </div>
      <ChatWidgetPreviewFrame
        chatWidget={promoter}
        channel={channel}
        className="customer-chat-preview__preview-frame"
        showGreeting="without_delay"
        includeDescriptions
      />
    </div>
  );
};
